import * as entities from '../entities'

import * as aiEdits from './aiEdits'
import * as aiHouse from './aiHouse'
import * as assets from './asset'
import * as configurations from './configuration'
import * as enums from './enum'
import * as jobs from './job'
import * as merchandiseOrderItems from './merchandiseOrderItem'
import * as merchandises from './merchandise'
import * as offices from './office'
import * as orderItems from './orderItem'
import * as orders from './order'
import * as partFiles from './partFile'
import * as posts from './post'
import * as prompts from './prompt'
import * as projectFiles from './projectFile'
import * as projects from './project'
import * as projectsSearch from './projectSearch'
import * as tasks from './task'
import * as taskSheets from './taskSheet'
import * as users from './user'

import * as emailRequests from './emailRequest'
import * as sqlAssets from './sqlAsset'
import * as sqlServiceJobs from './sqlServiceJob'

const modules = {
  entities,
  aiEdits,
  aiHouse,
  assets,
  configurations,
  enums,
  jobs,
  merchandiseOrderItems,
  merchandises,
  offices,
  orderItems,
  orders,
  partFiles,
  posts,
  prompts,
  projectFiles,
  projects,
  projectsSearch,
  tasks,
  taskSheets,
  users,
  // SQL related
  emailRequests,
  sqlAssets,
  sqlServiceJobs,
}

export const reducers = Object.keys(modules).reduce((acc, moduleKey) => {
  const module = modules[moduleKey]
  acc[moduleKey] = module.default

  return acc
}, {})

export default modules
